<template>
    <div class="auth animated fadeIn">
        <b-container class="app">
            <b-row align-v="center" align-h="center">
                <b-col cols="9" class="mt-5">
                    <router-view></router-view>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        name: 'Auth'
    }
</script>

<style scoped="auth" lang="scss">
    div.auth {
        background: url(../assets/img/slides/2.jpg) center no-repeat;
        background-size: cover;
    }
</style>


// WEBPACK FOOTER //
// Auth.vue?1547b838